import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const RouterActions = createActionGroup({
  source: 'Router',
  events: {
    Go: props<{ path: any[]; queryParams?: object; extras?: object }>(),
    'Navigate to event selection': emptyProps(),
    'Navigate to selected event': (eventId: number) => ({ eventId }),
    'Navigated to profile route': emptyProps()
  }
});
